// extracted by mini-css-extract-plugin
export default {"CountryOption":"styles_CountryOption__RZhqg","selected":"styles_selected__U6vjk","infoContainer":"styles_infoContainer__YB-MV","name":"styles_name__pNSyM"};